/* Solitude Sauna — global.js */
(function () {
  'use strict';
  var reduceMotion = (document.body && document.body.classList.contains('animations-off')) ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Mobile nav drawer ---------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-mobile-nav]');
  if (toggle && drawer) {
    var close = drawer.querySelector('[data-menu-close]');
    toggle.addEventListener('click', function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
    function shut() { drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
    if (close) close.addEventListener('click', shut);
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', shut); });
  }

  /* Auto-stagger children within grids tagged data-stagger (BEFORE collecting reveal els) */
  document.querySelectorAll('[data-stagger]').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      if (!child.classList.contains('reveal-clip')) child.classList.add('reveal');
      child.setAttribute('data-reveal-delay', i * 110);
    });
  });

  /* ---------- Scroll reveal + count-up (deterministic sweep) ---------- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.reveal, .reveal-clip, .reveal-text, [data-reveal]'));
  var countEls = Array.prototype.slice.call(document.querySelectorAll('[data-count]'));
  function runCount(el) {
    if (el.__counted) return; el.__counted = true;
    var target = parseFloat(el.getAttribute('data-count')) || 0, dec = (el.getAttribute('data-decimals') || 0) | 0;
    if (reduceMotion) { el.textContent = target.toFixed(dec); return; }
    var dur = 1500, start = null;
    function step(ts) { if (!start) start = ts; var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = (target * e).toFixed(dec); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  function sweep() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = revealEls.length - 1; i >= 0; i--) {
      if (revealEls[i].getBoundingClientRect().top < vh * 0.9) {
        revealEls[i].style.transitionDelay = (revealEls[i].getAttribute('data-reveal-delay') || 0) + 'ms';
        revealEls[i].classList.add('is-visible');
        revealEls.splice(i, 1);
      }
    }
    for (var j = countEls.length - 1; j >= 0; j--) {
      if (countEls[j].getBoundingClientRect().top < vh * 0.88) { runCount(countEls[j]); countEls.splice(j, 1); }
    }
  }
  if (reduceMotion) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    countEls.forEach(runCount);
  } else {
    var revTick = false;
    function onRevScroll() { if (!revTick) { revTick = true; requestAnimationFrame(function () { sweep(); revTick = false; }); } }
    window.addEventListener('scroll', onRevScroll, { passive: true });
    window.addEventListener('resize', onRevScroll);
    window.addEventListener('load', sweep);
    sweep();
  }

  /* ---------- Marquee (rAF-driven so it never blocks render tooling) ---------- */
  document.querySelectorAll('[data-marquee]').forEach(function (track) {
    if (reduceMotion) return;
    var x = 0, speed = parseFloat(track.getAttribute('data-speed')) || 0.4, half = 0, paused = false;
    function measure() { half = track.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure);
    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    function tick() {
      if (!paused && half) { x -= speed; if (-x >= half) x = 0; track.style.transform = 'translate3d(' + x + 'px,0,0)'; }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  });

  /* ---------- PDP gallery: thumb swap + lightbox + click-to-zoom ---------- */
  var mainImg = document.querySelector('[data-pdp-main]');
  if (mainImg) {
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-thumb]'));
    /* Full-resolution image list, in gallery order (main first, then thumbs) */
    var gImgs = [mainImg.getAttribute('data-full') || mainImg.getAttribute('src')];
    thumbs.forEach(function (t) { gImgs.push(t.getAttribute('data-full') || t.getAttribute('src')); });

    /* Thumb click swaps the main image */
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.src = thumb.getAttribute('data-full') || thumb.src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    /* Build the lightbox once */
    var lb = document.createElement('div');
    lb.className = 'pdp-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.innerHTML =
      '<button class="pdp-lb__close" type="button" aria-label="Close">×</button>' +
      '<button class="pdp-lb__nav pdp-lb__prev" type="button" aria-label="Previous">‹</button>' +
      '<div class="pdp-lb__stage"><img class="pdp-lb__img" alt="" src=""></div>' +
      '<button class="pdp-lb__nav pdp-lb__next" type="button" aria-label="Next">›</button>' +
      '<div class="pdp-lb__count"></div>';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('.pdp-lb__img');
    var lbCount = lb.querySelector('.pdp-lb__count');
    var idx = 0, zoomed = false;

    function unzoom() { zoomed = false; lbImg.classList.remove('is-zoomed'); lbImg.style.transformOrigin = 'center center'; }
    function render() { unzoom(); lbImg.src = gImgs[idx]; lbCount.textContent = (idx + 1) + ' / ' + gImgs.length; }
    function openLb(i) { idx = i; render(); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeLb() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
    function next() { idx = (idx + 1) % gImgs.length; render(); }
    function prev() { idx = (idx - 1 + gImgs.length) % gImgs.length; render(); }

    mainImg.addEventListener('click', function () {
      var cur = mainImg.getAttribute('src');
      var at = gImgs.indexOf(cur);
      openLb(at >= 0 ? at : 0);
    });

    lb.querySelector('.pdp-lb__close').addEventListener('click', closeLb);
    lb.querySelector('.pdp-lb__next').addEventListener('click', function (e) { e.stopPropagation(); next(); });
    lb.querySelector('.pdp-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || (e.target.classList && e.target.classList.contains('pdp-lb__stage'))) closeLb();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });

    /* Click image to toggle zoom; move to pan while zoomed */
    lbImg.addEventListener('click', function (e) {
      e.stopPropagation();
      zoomed = !zoomed;
      lbImg.classList.toggle('is-zoomed', zoomed);
      if (!zoomed) lbImg.style.transformOrigin = 'center center';
    });
    lbImg.addEventListener('mousemove', function (e) {
      if (!zoomed) return;
      var r = lbImg.getBoundingClientRect();
      lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
  }

  /* ---------- Variant selection ---------- */
  var pdpForm = document.querySelector('[data-product-form]');
  if (pdpForm && window.SolitudeProduct) {
    var product = window.SolitudeProduct;
    var idField = pdpForm.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-pdp-price]');
    var selects = pdpForm.querySelectorAll('[data-variant-option]');
    function fmt(c) { return '$' + (c / 100).toLocaleString('en-CA', { minimumFractionDigits: 2 }); }
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      if (match) {
        if (idField) idField.value = match.id;
        if (priceEl) priceEl.textContent = fmt(match.price);
        var btn = pdpForm.querySelector('[data-add]');
        if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? btn.dataset.label : 'Sold out'; }
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* ---------- Product page: real variants / deposit ---------- */
  var pp = document.querySelector('[data-product-page]');
  if (pp) {
    var depositPct = parseFloat(pp.getAttribute('data-deposit')) || 50;
    var pay = 'full';
    var variants = [];
    var vEl = pp.querySelector('[data-pdp-variants]');
    if (vEl) { try { variants = JSON.parse(vEl.textContent); } catch (e) { variants = []; } }
    var idField = pp.querySelector('input[name="id"]');
    var addBtn = pp.querySelector('[data-add]');
    var current = null;
    for (var vi = 0; vi < variants.length; vi++) { if (variants[vi].available) { current = variants[vi]; break; } }
    if (!current && variants.length) current = variants[0];
    var selected = current ? current.options.slice() : [];
    var base = current ? current.price : 0;

    function money(cents) {
      return '$' + (cents / 100).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function addonsTotal() {
      var t = 0;
      pp.querySelectorAll('[data-addon].is-on:not(.addon--hidden)').forEach(function (a) {
        t += parseInt(a.getAttribute('data-price'), 10) || 0;
      });
      return t;
    }
    function recalc() {
      var total = base + addonsTotal();
      var due = pay === 'deposit' ? Math.round(total * depositPct / 100) : total;
      var priceEl = pp.querySelector('[data-pdp-price]'); if (priceEl) priceEl.textContent = money(total);
      var noteEl = pp.querySelector('[data-pay-note]');
      if (pay === 'deposit') {
        if (noteEl) noteEl.innerHTML = 'Due today: <b data-due-today>' + money(due) + '</b> &middot; balance of ' + money(total - due) + ' before dispatch';
      } else {
        if (noteEl) noteEl.innerHTML = 'Due today: <b data-due-today>' + money(total) + '</b>';
      }
      var dueBtn = pp.querySelector('[data-due-btn]'); if (dueBtn) dueBtn.textContent = money(due);
    }
    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < selected.length; k++) { if (variants[i].options[k] !== selected[k]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function applyVariant() {
      var v = findVariant();
      if (v) {
        base = v.price;
        if (idField) idField.value = v.id;
        if (addBtn) { addBtn.disabled = !v.available; addBtn.style.opacity = v.available ? '' : '0.5'; }
        recalc();
      } else if (addBtn) {
        addBtn.disabled = true; addBtn.style.opacity = '0.5';
      }
    }
    /* Variant option pills */
    pp.querySelectorAll('[data-opt]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var pos = (parseInt(pill.getAttribute('data-opt-position'), 10) || 1) - 1;
        selected[pos] = pill.getAttribute('data-opt-value');
        var group = pill.parentElement;
        group.querySelectorAll('[data-opt]').forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var lbl = pp.querySelector('[data-opt-current="' + (pos + 1) + '"]'); if (lbl) lbl.textContent = selected[pos];
        applyVariant();
      });
    });

    function addonName(el) { return (el.getAttribute('data-name') || '').toLowerCase(); }
    function addonRole(el) { return (el.getAttribute('data-addon-role') || 'none').toLowerCase(); }
    function resetAddon(addon) {
      if (!addon) return;
      addon.classList.remove('is-on');
      var cb = addon.querySelector('input[type="checkbox"]');
      if (cb) cb.checked = false;
      var tg = addon.querySelector('.addon__toggle');
      if (tg) tg.textContent = 'Add';
    }

    var wifiAddon = null, solitudeAddon = null, woodstoveAddon = null;
    pp.querySelectorAll('[data-addon]').forEach(function (addon) {
      var name = addonName(addon);
      var role = addonRole(addon);
      if (!wifiAddon && (role === 'solitude_wifi' || (role === 'none' && (name.indexOf('wifi') !== -1 || name.indexOf('wi-fi') !== -1)))) wifiAddon = addon;
      if (!solitudeAddon && (role === 'solitude_heater' || (role === 'none' && name.indexOf('solitude') !== -1))) solitudeAddon = addon;
      if (!woodstoveAddon && (role === 'woodstove' || (role === 'none' && name.indexOf('woodstove') !== -1))) woodstoveAddon = addon;
    });
    function setWifiState(on) {
      if (!wifiAddon) return;
      if (on) {
        wifiAddon.classList.remove('addon--hidden');
      } else {
        wifiAddon.classList.add('addon--hidden');
        resetAddon(wifiAddon);
      }
    }
    if (wifiAddon) setWifiState(solitudeAddon ? solitudeAddon.classList.contains('is-on') : false);

    pp.querySelectorAll('[data-addon]').forEach(function (addon) {
      var cb = addon.querySelector('input[type="checkbox"]');
      var tg = addon.querySelector('.addon__toggle');
      addon.addEventListener('click', function (e) {
        e.preventDefault();
        addon.classList.toggle('is-on');
        var on = addon.classList.contains('is-on');
        if (cb) cb.checked = on;
        if (tg) tg.textContent = on ? 'Added' : 'Add';
        if (addon === solitudeAddon) {
          if (on) resetAddon(woodstoveAddon);
          setWifiState(on);
        } else if (addon === woodstoveAddon && on) {
          resetAddon(solitudeAddon);
          setWifiState(false);
        }
        recalc();
      });
    });

    /* Payment toggle */
    pp.querySelectorAll('[data-pay]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        pp.querySelectorAll('[data-pay]').forEach(function (p) { p.classList.remove('is-active'); });
        opt.classList.add('is-active');
        pay = opt.getAttribute('data-pay');
        var inp = pp.querySelector('[data-pay-input]');
        if (inp) inp.value = pay === 'deposit' ? (depositPct + '% deposit') : 'Pay in full';
        recalc();
      });
    });

    applyVariant();
  }
})();
